const DEFAULT_LABELS = {
  provider: 'Assigned to',
  document_priority: 'High priority',
  document_reviewed: 'Reviewed',
  notes: 'Description',
};

const documentDefaultLabel = (key) => DEFAULT_LABELS[key] || key.replace(/_/g, ' ');

export default documentDefaultLabel;
